import { ChevronDown, ChevronUp } from "lucide-react";
import React, { useState } from "react";

interface CollapsibleSectionProps {
  title: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  className?: string;
}

export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  children,
  defaultExpanded = false,
  className = "",
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className={`border border-gray-200 rounded-jobesta overflow-hidden ${className}`}>
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between p-3 bg-jobesta-gray-30 hover:bg-jobesta-gray-40 transition-colors"
      >
        <span className="text-sm font-medium text-jobesta-gray-90">{title}</span>
        {isExpanded ? (
          <ChevronUp className="w-4 h-4 text-jobesta-gray-60 transition-transform duration-200" />
        ) : (
          <ChevronDown className="w-4 h-4 text-jobesta-gray-60 transition-transform duration-200" />
        )}
      </button>
      <div
        className={`transition-all duration-200 ease-in-out overflow-hidden ${
          isExpanded ? "max-h-[2000px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="p-3 bg-white">{children}</div>
      </div>
    </div>
  );
};

export default CollapsibleSection;
